var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.816326 13.3333C0.816326 14.2542 1.54694 15 2.44898 15H8.97959C9.88163 15 10.6122 14.2542 10.6122 13.3333V3.33333H0.816326V13.3333ZM11.4286 0.833333H8.57143L7.7551 0H3.67347L2.85714 0.833333H0V2.5H11.4286V0.833333Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteChat);
export default __webpack_public_path__ + "static/media/deleteChat.4e499d408a04648b5287fdedc9bfff74.svg";
export { ForwardRef as ReactComponent };